import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import { useDispatch } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  salesDeliveryViewAction,
  salesOrderItemsGetAction,
  salesReturnItemsGetAction,
  pickListItemsGetAction,
} from "../../../redux/actions/sales-action";
import CreateEditViewSalesDelivery from "../../../components/sales-section/delivery-section/create-edit-view-sales-delivery";
import errorToast from "../../../components/helper-components/error-toast";

const AddDelivery = () => {
  const { itemId, type } = useParams();
  const [searchParams] = useSearchParams();

  const itemIdArray = JSON.parse(decodeURIComponent(itemId));
  //
  const cloneID = searchParams.get("cloneID");
  const isClone = cloneID ? true : false;
  //
  const allitems = itemIdArray.map((item) => {
    const { cmr_id, ...rest } = item;
    return rest;
  });
  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    if (isClone) {
      setLoading(true);
      dispatch(salesDeliveryViewAction(cloneID, onCloneSuccPur, onErrPur));
    } else if (type === "return") {
      setLoading(true);
      dispatch(salesReturnItemsGetAction(allitems, onSuccPur, onErrPur));
    } else if (type === "picklist") {
      setLoading(true);
      dispatch(pickListItemsGetAction(allitems, onSuccPur, onErrPur));
    } else if(transfer===true){ 
      setLoading(true);
      dispatch(salesOrderItemsGetAction(allitems, onSuccPur, onErrPur));
    }
  }, []);

  const onCloneSuccPur = (data) => {
    setOrderDetail(data?.data?.[0]);
    setLoading(false);
  };

  const onSuccPur = (data) => {
    if(data?.code == 400){
      errorToast(data?.message || "Something went wrong");
      setLoading(false);
      navigate("/picklist-table");
      return;
    }
    setOrderDetail(data?.data);
    setLoading(false);
  };

  const onErrPur = (data) => {
    errorToast(data?.data?.message || "Something went wrong");
    setLoading(false);
  };
  const orderData = orderDetail?.orderData || {};
  const vendorDetails = orderDetail?.vendorDetails?.[0] || {};

  const prefix = searchParams.get("type") || "sott";
  const isNew = searchParams.has("new");
  const auto = searchParams.has("auto");
  const transfer=searchParams.has("transfer");
  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout
          backBtn={true}
          title={`${isClone ? "Clone" : "Add"} Delivery Note`}
        >
          {console.log("===", vendorDetails, orderData)}

          <CreateEditViewSalesDelivery
            transfer={transfer===true}
            isClone={isClone}
            auto={auto}
            fromPicklist={type === "picklist"}
            page="add"
            clickedplus={isNew}
            pageType="delivary"
            standAlone={type === "delivery"}
            type={type}
            payto={
              isClone
                ? orderDetail?.orderData?.sodtt_pay_to_address
                : vendorDetails?.[`${prefix}_pay_to_address`]
            }
            shipto={
              isClone
                ? orderDetail?.orderData?.sodtt_ship_to_address
                : vendorDetails?.[`${prefix}_ship_to_address`]
            }
            itemData={orderDetail?.itemData}
            //
            vendorDetails={
              isClone
                ? [orderDetail?.orderData]
                : [
                    {
                      ...vendorDetails,
                      sodtt_sub_total: orderData?.sub_total,
                      sodtt_total_gst: orderData?.total_tax,
                      sodtt_total_discount: orderData?.total_discount,
                      sodtt_total_amount: orderData?.total_amount,
                      sodtt_round_off_value: orderData?.round_off_value,
                      sodtt_tcs_or_tds_amount: orderData?.tcs_or_tds_amount,
                      sodtt_tcs_or_tds_percentage_id:
                        orderData?.tcs_or_tds_percentage_id,
                      sodtt_tcs_or_tds_percentage:
                        orderData?.tcs_or_tds_percentage,
                      sodtt_tds_tcs_type: orderData?.tcs_or_tds_type,
                      sodtt_is_invoice_dis_percentage:
                        orderData?.is_invoice_dis_percentage ?? true,
                      sodtt_invoice_discount: orderData?.invoice_discount ?? 0,
                      sodtt_invoice_discount_percentage:
                        orderData?.invoice_discount_percentage ?? 0,
                    },
                  ]
            }
            //

            orderDetail={orderDetail?.itemData}
          />
        </InnerLayout>
      )}
    </>
  );
};
export default AddDelivery;
